import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
const swal = require('sweetalert');
@Component({
  selector: 'app-delete-beneficiarie',
  templateUrl: './delete-beneficiarie.component.html',
  styleUrls: ['./delete-beneficiarie.component.scss']
})
export class DeleteBeneficiarieComponent implements OnInit {
  viewid:any;
  rows;
  Bid:any;
  row:any;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService,private router:Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });

    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.ViewBeneficiarieDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
     this.rows=result;
     if(this.rows.BankCodeType==0)
   {
     this.rows.BankCodeType="RoutingTransitNumber"
   }
   else if(this.rows.BankCodeType==1)
   {
     this.rows.BankCodeType="BankSortCodes"
   }
   else if(this.rows.BankCodeType==2)
   {
     this.rows.BankCodeType="BsbNumbers"
   }
   else if(this.rows.BankCodeType==3)
   {
     this.rows.BankCodeType="SwiftCode"
   }
   else if(this.rows.BankCodeType==4)
   {
     this.rows.BankCodeType="MicrCode"
   }
   else if(this.rows.BankCodeType==5)
   {
     this.rows.BankCodeType="IfscCode"
   }
   if(this.rows.BankAccountType==0)
   {
     this.rows.BankAccountType="SalaryAccount"
   }
   else if(this.rows.BankAccountType==1)
   {
     this.rows.BankAccountType="CurrentAccount"
   }
   else if(this.rows.BankAccountType==2)
   {
     this.rows.BankAccountType="SavingAccount"
   }
   else if(this.rows.BankAccountType==3)
   {
     this.rows.BankAccountType="RecurringDeposits"
   }
   else if(this.rows.BankAccountType==4)
   {
     this.rows.BankAccountType="FixedDeposits"
   }
    })

   }

  ngOnInit() {
  }

  openConfirmationDialog() {

    swal({

      title: 'Are you sure you want to delete?',
      // text: 'Are you sure you want to delete?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel!',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes, delete it!',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.DeleteContact();
      } else {
        // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }
  DeleteContact()
  {
    let form = {
      
      MerchantKeyId: 0,
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      BankCodeType: "",
      BankName: "",
      BranchName: "",
      BankCode: "",
      AccountNumber: "",
      BankAccountType: "",
      BankCountry: "",
      VerificationStatus: "",
      VerificationResponse: "",
      UpiVpa: "",
      PreferPayOutAccount: "",
      UpdatedUserName: "",
      Id:0,
      LoginUserId:''
    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;

   
   form.PayOutBeneficiaryKeyId=  this.rows.PayOutBeneficiaryKeyId;
   form.PayoutCustomerkeyId=  this.rows.PayoutCustomerkeyId;
   form.BankCodeType=  this.rows.BankCodeType;
   form.BankName=  this.rows.BankName;
   form.BranchName=  this.rows.BranchName;
   form.BankCode=  this.rows.BankCode;
   form.AccountNumber=  this.rows.AccountNumber;
   form.BankAccountType=  this.rows.BankAccountType;
   form.BankCountry=  this.rows.BankCountry;  
   form.VerificationStatus=  this.rows.VerificationStatus;
   form.VerificationResponse=  this.rows.VerificationResponse;
   form.UpiVpa= this.rows.UpiVpa;
   form.PreferPayOutAccount=  this.rows.PreferPayOutAccount;
   form.Id=this.rows.Id;
   form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
   this.service.deleteBeneficiarie(form).subscribe(result => {
    
    if (result != null) {

      swal("Deleted", "Beneficiary Deleted Successfully", "success");
      this.router.navigate(["PayOut/BeneficiaryList"]);
    }
  });

  }
}
